module.exports = __webpack_public_path__ + "catalog/items/heating_Electrical/Boiler/Boiler.svg";